// PDFViewer.js
import { Button } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = ({ pdfurl, view }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = (numPages) => {
        setNumPages(numPages);
    }

    const handleDownloadClick = async () => {
        try {
            const response = await fetch(pdfurl); // Replace with the actual PDF URL
            const blob = await response.blob();

            // Create a temporary URL for the Blob
            const blobUrl = URL.createObjectURL(blob);

            // Create an anchor element for downloading
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'application.pdf'; // You can change the downloaded file name here
            document.body.appendChild(link);

            // Trigger the click event on the anchor element
            link.click();

            // Clean up
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error downloading PDF:', error);
        }
    }

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }

    }, [])
    return (
        <div className='w-full px-5'>
            {isMobile == true &&
                <div className="flex p-4">
                    <div className="flex-grow">
                        <p className='text-[12px] font-semibold text-instruction-grey mt-2'>Preview Application Form:</p>
                    </div>
                    <div>
                        <Button onClick={handleDownloadClick} type='primary'>Download</Button>
                    </div>
                </div>
            }
            <div className='pdf-viewer-control' style={isMobile === true ? { width: '100%' } : null}>
                {isMobile !== true ? (
                    <iframe src={pdfurl} id='pdf' title="PDF Viewer" width="100%" height="100%" />
                ) : (
                    <Fragment>
                        <Document file={pdfurl} onLoadSuccess={onDocumentLoadSuccess}>
                            <Page pageNumber={1} />
                        </Document>
                    </Fragment>
                )}
            </div>
            {isMobile == true &&
                <div className='text-center mt-2'>
                </div>
            }
        </div>
    );
};

export default PdfViewer;
